import React, {Component} from 'react';
import {STEP_DATE_RECEPTION, STEP_GENERAL_INFORMATION, STEP_PERSONAL_INFORMATION, STEP_SERVICE_MOBILITY, STEP_SUMMARY,} from '../definition/business';
import GeneralInformationFragment from './GeneralInformationFragment';
import ServicesMobilityFragment from "./services/ServicesMobilityFragment";
import DateReceptionFragment from './DateReceptionFragment';
import PersonalInformationFragment from './PersonalInformationFragment';
import SummaryFragment from './SummaryFragment';
import connect from "react-redux/es/connect/connect";

class AppointmentStepScreenFragment extends Component {
  render() {
    const {
      selectedDate,
      selectedSlot,
      reception,
      sizeClass,
      availabilities,
      selectedDealer,
      selectedVIN,
      customerPreJourneyInfo,
      methods,
      number,
      street,
      zipCode,
      city,
      country,
      stepper
    } = this.props;
    switch (stepper.currentStep) {
      case STEP_GENERAL_INFORMATION:
        return (
          <GeneralInformationFragment
            leasingCompanies={customerPreJourneyInfo.leasingCompanies}
            selectedDealer={selectedDealer}
            selectedVIN={selectedVIN}
          />
        );
      case STEP_SERVICE_MOBILITY:
        return(
          <ServicesMobilityFragment type={customerPreJourneyInfo.type}/>
        );
      case STEP_DATE_RECEPTION:
        return (
          <DateReceptionFragment
            onSelectDate={methods.onSelectDate}
            onSelectSlot={methods.onSelectSlot}
            onReceptionChange={methods.onReceptionChange}
            setAvailabilities={methods.setAvailabilities}
            selectedDate={selectedDate}
            selectedSlot={selectedSlot}
            availabilities={availabilities}
            reception={reception}
            sizeClass={sizeClass}
            selectedVIN={selectedVIN}
            selectedDealer={selectedDealer}
            mobility={customerPreJourneyInfo.mobility}
            type={customerPreJourneyInfo.type}
            untrustedVinwOffering={customerPreJourneyInfo.untrustedVinwOffering}
          />
        );
      case STEP_PERSONAL_INFORMATION:
        return (
          <PersonalInformationFragment
            onNumberChange={methods.onNumberChange}
            onStreetChange={methods.onStreetChange}
            onZipCodeChange={methods.onZipCodeChange}
            onCityChange={methods.onCityChange}
            onCountryChange={methods.onCountryChange}
            mobility={customerPreJourneyInfo.mobility}
            number={number}
            street={street}
            zipCode={zipCode}
            city={city}
            country={country}
            selectedDate={selectedDate}
          />
        );
      case STEP_SUMMARY:
        return (
          <SummaryFragment
            reception={reception}
            number={number}
            street={street}
            zipCode={zipCode}
            city={city}
            country={country}
            mobility={customerPreJourneyInfo.mobility}
            type={customerPreJourneyInfo.type}
          />
        );
      default:
        return null;
    }
  }
}

const mapDispatchToProps = dispatch => ({

});

const mapStateToProps = state => ({
  stepper: state.stepper,
  selectedDealer: state.customerDealer.selectedDealer,
  customerPreJourneyInfo: state.customerPreJourneyInfo.preJourneyInfo,
});

export default
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(AppointmentStepScreenFragment);

